import { Component, OnInit, Input, Output, EventEmitter, DoCheck, AfterViewChecked, ElementRef, ViewChild, AfterViewInit, ChangeDetectorRef, HostListener, inject } from '@angular/core';

import { ChatModel, ChatRequestMessageModel } from '../../models';

import { AppB2cService, SessionService, SpeechRecognitionService } from '../../services';
import { AppProperty } from '../../properties';
import { SidebarModule } from 'primeng/sidebar';
import { PrimeTemplate } from 'primeng/api';
import { MarkdownComponent } from 'ngx-markdown';
import { Button } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { Ripple } from 'primeng/ripple';
import { TranslateModule } from '@ngx-translate/core';
import { DebugLoggerService } from '../../services/debug-logger.service';


@Component({
  selector: 'am-copilot',
  templateUrl: './am-copilot.component.html',
  styleUrls: ['./am-copilot.component.scss'],
  standalone: true,
  imports: [SidebarModule, PrimeTemplate, MarkdownComponent, Button, FormsModule, InputTextareaModule, Ripple, TranslateModule]
})
export class AmCopilotComponent implements OnInit {
  private _b2cService = inject(AppB2cService);
  appProperty = inject(AppProperty);
  speechRecognitionService = inject(SpeechRecognitionService);
  sessionService = inject(SessionService);
  private _debugLogger = inject(DebugLoggerService);


  @ViewChild('chatContainer') private chatContainer: ElementRef;
  @ViewChild('userInputArea') userInputArea!: ElementRef;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() { }

  @Input() visible: boolean = false;
  @Output() close: EventEmitter<boolean> = new EventEmitter();

  innerWidth: any;

  @HostListener('window: resize', ['$event'])
  onresize(event) {
    this.innerWidth = window.innerWidth;
  }


  startingMessage: boolean = false;
  assistantIsThinking: boolean = false;
  chatModel: ChatModel;
  

  userFirstMessage: string = '';

  providerModel: any = {}

  logoSrc = '/assets/login/logoAmSuite.png';

  ngOnInit() {
    this._debugLogger.logLifecycle('Copilot', 'ngOnInit');
    this.innerWidth = window.innerWidth;
    this.newChat();
  }

  getSidebarClass() {
    if (this.innerWidth <= 700)
      return 'w-12'
    else if (this.innerWidth <= 1000)
      return 'w-10'
    else if (this.innerWidth <= 1200)
      return 'w-9'
    else if (this.innerWidth <= 1400)
      return 'w-8'
    else if (this.innerWidth <= 1500)
      return 'w-7'
    else
      return 'w-5'
  }

  setFocus() {

    const interval = setInterval(() => {
      const userInputElement = document.getElementById('userInputArea');
      if (userInputElement) {
        (userInputElement as HTMLInputElement).focus();
        clearInterval(interval);
      }
    }, 100);
  }

  //! TODO Aggiungere scroll in basso alla risposta di Assistant

  newChat() {
    this._debugLogger.logAction('Copilot', 'newChat');
    this.chatModel = undefined;
    this.startingMessage = true;
    this.appProperty.assistantUserMessage = '';
  }


  canSendMessage() {
    return !this.assistantIsThinking
      && this.appProperty.assistantUserMessage
      && this.appProperty.assistantUserMessage.trim().length > 0;
  }

  runChat() {
    if (!this.chatModel)
      return this.startChat();
    else
      return this.sendMessage();
  }

  startChat() {
    this.assistantIsThinking = true;

    let copiedMessage: string = this.appProperty.assistantUserMessage;
    this.appProperty.assistantUserMessage = '';
    this.userFirstMessage = copiedMessage;

    let jsonParams = {
      userMessage: copiedMessage,
    }

    this._debugLogger.logAction('Copilot', 'startChat', { message: copiedMessage });
    this._b2cService.startChat(jsonParams).subscribe((res: any) => {
      this.chatModel = new ChatModel(res);
      this._debugLogger.logAction('Copilot', 'chat started', { chatId: this.chatModel?.id });
      this.userFirstMessage = '';
      this.startingMessage = false;
      this.assistantIsThinking = false;

      this.setFocus();

    }, error => {
      this._debugLogger.logError('Copilot', 'startChat failed', error);

      let chatModel: ChatRequestMessageModel = {
        role: 2,
        content: 'Mi dispiace, si è verificato un errore. Riprova aprendo una nuova chat'
      }
      this.chatModel.chat.push(chatModel)
      this.assistantIsThinking = false;
      this.setFocus();
    });
  }


  sendMessage() {
    if (!this.canSendMessage())
      return;

    this.stop();
    this.assistantIsThinking = true;

    let copiedMessage: string = this.appProperty.assistantUserMessage;
    this.appProperty.assistantUserMessage = '';

    let jsonParams = {
      chatId: this.chatModel.id,
      userMessage: copiedMessage
    }

    let chatModel: ChatRequestMessageModel = {
      role: 2,
      content: copiedMessage
    }
    this.chatModel.chat.push(chatModel)

    this._debugLogger.logAction('Copilot', 'sendMessage', { chatId: this.chatModel.id, message: copiedMessage });
    this._b2cService.sendMessage(jsonParams).subscribe((res: any) => {
      this.chatModel.chat.push(new ChatRequestMessageModel(res));
      this._debugLogger.logAction('Copilot', 'message response received');
      this.assistantIsThinking = false;

      this.setFocus();

    }, error => {
      this._debugLogger.logError('Copilot', 'sendMessage failed', error);
      let chatModel: ChatRequestMessageModel = {
        role: 2,
        content: 'Mi dispiace, si è verificato un errore. Riprova aprendo una nuova chat'
      }
      this.chatModel.chat.push(chatModel)
      this.assistantIsThinking = false;

      this.setFocus();
    });
  }

  start(): void {
    this.speechRecognitionService.startListening();
  }

  stop(): void {
    this.speechRecognitionService.stopListening();
  }

  setPrompt(prompt: string) {
    this.appProperty.assistantUserMessage = prompt;
  }

  closeSidebar() {
    this.visible = false;
    this.close.emit(true);
  }

}
